var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37 20a7.036 7.036 0 01-4.742-1.8 7.2 7.2 0 01-2.4-5.2 7.29 7.29 0 012.118-5.312L9.6.432a1.501 1.501 0 012.124 2.122L4.468 9.81a4.252 4.252 0 00.166 6.17 4.482 4.482 0 006.076-.4l5.672-5.662A1.355 1.355 0 1014.468 8l-4.62 4.62a1.5 1.5 0 01-2.122-2.12l4.622-4.616a4.352 4.352 0 016.156 6.154l-5.674 5.674A7.736 7.736 0 017.37 20z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.c7c6072a.svg";
export { ForwardRef as ReactComponent };